import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { clearCookieKeys, getFromDecreaptLocalStorage, removeCookieValue, titleCase } from '../utilFunctions';
import { useMsal } from '@azure/msal-react';
import LineOfBusiness from '../utilsComponent/LineOfBusiness';
import { Modal } from 'react-bootstrap';
import { BUSINESS_OPTIONS } from '../consts';

const Profile = (props) => {
    const { roleDataCookie , setReRender} = props
    const [openDropDown, setOpenDropDown] = useState(false)
    const [roleName, setRoleName] = useState("")
    const navigate = useNavigate();
    const { instance } = useMsal();
    const [showModal, setShowModal] = useState(false);
    const [lineOfBusiness, setLineOfBusiness] = useState(getFromDecreaptLocalStorage("lineOfBusiness", true))

    const handleLineOfBusinessChange = (business) => {
        setShowModal(false);
        setLineOfBusiness(business);
        setReRender((prev) => (!prev))
    }

    return (
        <div>
            <div className="profile">
                {roleDataCookie && (
                    <>
                        <div className="profile-heading">
                            <span className='mx-5 cursor-pointer' onClick={() => {
                                setShowModal(true)
                            }}> <img src={BUSINESS_OPTIONS.find(business => business.key === lineOfBusiness)?.icon} height={"15"} className='pe-1'/>{BUSINESS_OPTIONS.find(business => business.key === lineOfBusiness)?.name} <i className='fa fa-angle-down '></i></span>
                            {roleDataCookie?.employeeName}
                        </div>
                        <div className="designation pt-1">
                            {decodeURIComponent(roleDataCookie?.roleName)}
                        </div>
                    </>
                )}
            </div>
            <div className="profile-photo">
                <img
                    alt="Profile-picture"
                    className="profile-photo"
                    height="40px"
                    src="/kshemaImages/Profile-picture.png"
                    title="Upload Profile Photo"
                    width="40px"

                />
            </div>
            <p className="dropdown">
            </p>
            <div
                className="dropbtn"
                id="arrow_logout"
            >
                <i className="fa fa-angle-down dropdown-arrow pointer" onClick={() => setOpenDropDown(!openDropDown)} />

                {
                    openDropDown && (
                        <div
                            className="dropdown-content"
                            id="btn_dropdown"
                        >
                            <a className='pointer' onClick={() => { clearCookieKeys(); localStorage.removeItem("is_omdcUser"); instance.logoutRedirect() }}>
                                Logout
                            </a>
                        </div>
                    )
                }
            </div>
            <p />
            <Modal show={showModal} size='lg' centered={true} backdrop={'false'} >
                <Modal.Body>
                    <span onClick={() => { setShowModal(false) }} className="custom-close float-end">
                        &times;
                        </span>
                    <LineOfBusiness onChange={(business) => {
                        handleLineOfBusinessChange(business)
                    }}/>
                </Modal.Body>

            </Modal>
        </div>
    )
}

export default Profile
